import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { BaseService } from "./base.service";
import { MetaDataMapping } from "../models/meta-data.model";
import {
  TopLevelFieldMapping,
  TopLevelFieldMappingRel,
} from "../models/top-level-field-mapping.model";

@Injectable()
export class DataDictionaryService extends BaseService {
  constructor(protected http: Http) {
    super(http);
  }

  async getTopLevelDataMappings(): Promise<Array<TopLevelFieldMapping>> {
    return this.get("data-dictionary/top-level-mappings");
  }

  async getTopLevelDetails(
    topLevelSpreadsheetId: string,
    topLevelColumnId: string
  ): Promise<Array<TopLevelFieldMappingRel>> {
    return this.get(
      `data-dictionary/top-level-details/${topLevelSpreadsheetId}/${topLevelColumnId}`
    );
  }

  async getSourceFieldMappings(query: string): Promise<Array<MetaDataMapping>> {
    return this.get(`data-dictionary/source-field-mappings/${query}`);
  }

  async findTopLevelMapping(
    sourceFieldMapping: MetaDataMapping
  ): Promise<TopLevelFieldMapping> {
    return this.get(
      `data-dictionary/find-top-level-mapping/${sourceFieldMapping.spreadsheetId}/${sourceFieldMapping.columnId}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/data-dictionary.service.ts